const stringUtils = {
    insert(source, index, stringToInsert) {
        return source.slice(0, index) + stringToInsert + source.slice(index);
    },

    replaceChar(target, index, stringToInsert) {
        return target.slice(0, index) + stringToInsert + target.slice(index + 1);
    },
};

export default stringUtils;
